// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  padding: 0 0;
  margin: 0 0;
  min-width: 150px;
  border-radius: var(--border-radius);
  box-shadow: 0 1px var(--spacing2) var(--shadow-gray-dark);
  background-color: rgb(var(--white));
}

.popup-info {
  padding: var(--spacing3);
  width: 300px;
}

.popup-info__title {
  font-weight: bold;
  padding-bottom: var(--spacing3);
  display: inline-flex;
  width: 100%;
  line-height: var(--spacing4);
}
.popup-info__title .popup-info__title__text {
  width: calc(100% - var(--spacing4));
}
.popup-info__title .popup-info__title__icon-close {
  color: rgb(var(--gray-color-25));
  cursor: pointer;
}
.popup-info__title .popup-info__title__icon-close:hover {
  color: rgb(var(--black));
}

.popup-info__pie-chart .popup-info__pie-chart-circle {
  height: var(--spacing4);
  width: var(--spacing4);
}
.popup-info__pie-chart .popup-info__pie-chart-circle,
.popup-info__pie-chart .popup-info__pie-chart-description {
  display: inline;
  vertical-align: top;
}

.popup-info__buttons-row {
  padding-top: var(--spacing3);
}
.popup-info__buttons-row > :not(:first-child) {
  padding-left: var(--spacing1);
}
.popup-info__buttons-row.popup-info__buttons-row--apply {
  float: inline-end;
  padding-bottom: var(--spacing3);
}

.popup-info__description {
  margin-top: var(--spacing2);
}

.popup-info__connect {
  margin-top: var(--spacing2);
}
.popup-info__connect .popup-info__connect__item {
  line-height: var(--spacing5);
}
.popup-info__connect .popup-info__connect__item .lg-selection-checkbox {
  margin-right: var(--spacing0);
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./libs/shared/feature-comparison-picker/src/lib/comparison-picker-info/comparison-picker-popup-info/comparison-picker-popup-info.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mCAAA;EACA,yDAAA;EACA,mCAAA;AADJ;;AAIA;EACI,wBAAA;EACA,YAAA;AADJ;;AAIA;EACI,iBAAA;EACA,+BAAA;EACA,oBAAA;EACA,WAAA;EACA,4BAAA;AADJ;AAGI;EACI,mCAAA;AADR;AAII;EACI,gCAAA;EACA,eAAA;AAFR;AAIQ;EACI,wBAAA;AAFZ;;AAQI;EACI,uBAAA;EACA,sBAAA;AALR;AAQI;;EAEI,eAAA;EACA,mBAAA;AANR;;AAUA;EACI,4BAAA;AAPJ;AASI;EACI,6BAAA;AAPR;AAUI;EACI,iBAAA;EACA,+BAAA;AARR;;AAYA;EACI,2BAAA;AATJ;;AAYA;EACI,2BAAA;AATJ;AAWI;EACI,4BAAA;AATR;AAWQ;EACI,6BAAA;EACA,qBAAA;AATZ","sourcesContent":["@use \"definitions\" as *;\n\n:host {\n    padding: 0 0;\n    margin: 0 0;\n    min-width: 150px;\n    border-radius: var(--border-radius);\n    box-shadow: 0 1px var(--spacing2) var(--shadow-gray-dark);\n    background-color: lg-color(--white);\n}\n\n.popup-info {\n    padding: var(--spacing3);\n    width: 300px;\n}\n\n.popup-info__title {\n    font-weight: bold;\n    padding-bottom: var(--spacing3);\n    display: inline-flex;\n    width: 100%;\n    line-height: var(--spacing4);\n\n    .popup-info__title__text {\n        width: calc(100% - var(--spacing4));\n    }\n\n    .popup-info__title__icon-close {\n        color: lg-color(--gray-color-25);\n        cursor: pointer;\n\n        &:hover {\n            color: lg-color(--black);\n        }\n    }\n}\n\n.popup-info__pie-chart {\n    .popup-info__pie-chart-circle {\n        height: var(--spacing4);\n        width: var(--spacing4);\n    }\n\n    .popup-info__pie-chart-circle,\n    .popup-info__pie-chart-description {\n        display: inline;\n        vertical-align: top;\n    }\n}\n\n.popup-info__buttons-row {\n    padding-top: var(--spacing3);\n\n    > :not(:first-child) {\n        padding-left: var(--spacing1);\n    }\n\n    &.popup-info__buttons-row--apply {\n        float: inline-end;\n        padding-bottom: var(--spacing3);\n    }\n}\n\n.popup-info__description {\n    margin-top: var(--spacing2);\n}\n\n.popup-info__connect {\n    margin-top: var(--spacing2);\n\n    .popup-info__connect__item {\n        line-height: var(--spacing5);\n\n        .lg-selection-checkbox {\n            margin-right: var(--spacing0);\n            display: inline-block;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
